/* @flow */

import type { Config } from "shop-state/types";

const config: Config = {
  host: "localhost",
  port: 9433,
  apiHost: {
    server: "http://127.0.0.1",
    client: "",
    headers: ["SSL", "Ssl-Offload", "X-Forwarded-Proto", "Host", "X-Real-Ip", "X-Forwarded-For", "Cookie"],
  },
  googleAnalytics: [],
  altapay: {
    src: "https://awardit.altapaysecure.com/checkout/v1/js/AltaPaySDK.js",
  },
  datadog: {
    cspUri: null,
  },
};

module.exports = config;
